"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScheduledBreakPaywall = exports.RetrofitPaywall = exports.ContactAdmin = exports.AllowSubaccountsPaywall = exports.SingleFileSizeLimitPaywall = exports.CustomDomainPaywall = exports.PasswordProtectedLargeFileLinksPaywall = exports.FileStoragePaywall = exports.CustomFileTransferUrlPaywall = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _withStyles = _interopRequireDefault(require("@material-ui/styles/withStyles"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _Clear = _interopRequireDefault(require("@material-ui/icons/Clear"));

var _Button = _interopRequireDefault(require("../Button"));

var _Image = _interopRequireWildcard(require("../Image"));

var CustomFileTransferUrlPaywall = function CustomFileTransferUrlPaywall(_ref) {
  var onUpgrade = _ref.onUpgrade,
      onClose = _ref.onClose,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["onUpgrade", "onClose"]);

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var image = /*#__PURE__*/_react["default"].createElement(Image, {
    src: (0, _Image.withThemeSrc)(t('paywall.customFileTransferUrl.image.src'), t('paywall.customFileTransferUrl.darkImage.src')),
    alt: t('paywall.customFileTransferUrl.image.alt')
  });

  return /*#__PURE__*/_react["default"].createElement(Layout, (0, _extends2["default"])({
    onUpgrade: onUpgrade,
    onClose: onClose,
    title: t('paywall.customFileTransferUrl.title'),
    subtitle: t('paywall.customFileTransferUrl.subtitle'),
    image: image
  }, rest), t('paywall.customFileTransferUrl.children'));
};

exports.CustomFileTransferUrlPaywall = CustomFileTransferUrlPaywall;

var FileStoragePaywall = function FileStoragePaywall(_ref2) {
  var _ref2$isFull = _ref2.isFull,
      isFull = _ref2$isFull === void 0 ? false : _ref2$isFull,
      available = _ref2.available,
      limit = _ref2.limit,
      _ref2$noUpgrade = _ref2.noUpgrade,
      noUpgrade = _ref2$noUpgrade === void 0 ? false : _ref2$noUpgrade,
      onUpgrade = _ref2.onUpgrade,
      onClose = _ref2.onClose,
      rest = (0, _objectWithoutProperties2["default"])(_ref2, ["isFull", "available", "limit", "noUpgrade", "onUpgrade", "onClose"]);

  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation2.t;

  var image = /*#__PURE__*/_react["default"].createElement(Image, {
    src: (0, _Image.withThemeSrc)(t('paywall.fileStorage.image.src'), t('paywall.fileStorage.darkImage.src')),
    alt: t('paywall.fileStorage.image.alt')
  });

  var children = t('paywall.fileStorage.children');

  if (noUpgrade) {
    children = isFull ? t('paywall.fileStorage.children.noUpgrade.isFull') : t('paywall.fileStorage.children.noUpgrade', {
      available: available,
      limit: limit
    });
  } else {
    children = isFull ? t('paywall.fileStorage.children.isFull') : t('paywall.fileStorage.children');
  }

  return /*#__PURE__*/_react["default"].createElement(Layout, (0, _extends2["default"])({
    onUpgrade: !noUpgrade ? onUpgrade : undefined,
    onClose: onClose,
    title: t('paywall.fileStorage.title'),
    subtitle: t('paywall.fileStorage.subtitle'),
    image: image
  }, rest), children);
};

exports.FileStoragePaywall = FileStoragePaywall;

var PasswordProtectedLargeFileLinksPaywall = function PasswordProtectedLargeFileLinksPaywall(_ref3) {
  var onUpgrade = _ref3.onUpgrade,
      onClose = _ref3.onClose,
      rest = (0, _objectWithoutProperties2["default"])(_ref3, ["onUpgrade", "onClose"]);

  var _useTranslation3 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation3.t;

  var image = /*#__PURE__*/_react["default"].createElement(Image, {
    src: (0, _Image.withThemeSrc)(t('paywall.passwordProtectedLargeFileLinks.image.src'), t('paywall.passwordProtectedLargeFileLinks.darkImage.src')),
    alt: t('paywall.passwordProtectedLargeFileLinks.image.alt')
  });

  return /*#__PURE__*/_react["default"].createElement(Layout, (0, _extends2["default"])({
    onUpgrade: onUpgrade,
    onClose: onClose,
    title: t('paywall.passwordProtectedLargeFileLinks.title'),
    subtitle: t('paywall.passwordProtectedLargeFileLinks.subtitle'),
    image: image
  }, rest), t('paywall.passwordProtectedLargeFileLinks.children'));
};

exports.PasswordProtectedLargeFileLinksPaywall = PasswordProtectedLargeFileLinksPaywall;

var CustomDomainPaywall = function CustomDomainPaywall(_ref4) {
  var onUpgrade = _ref4.onUpgrade,
      onClose = _ref4.onClose,
      rest = (0, _objectWithoutProperties2["default"])(_ref4, ["onUpgrade", "onClose"]);

  var _useTranslation4 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation4.t;

  var image = /*#__PURE__*/_react["default"].createElement(Image, {
    src: (0, _Image.withThemeSrc)(t('paywall.customDomain.image.src'), t('paywall.customDomain.darkImage.src')),
    alt: t('paywall.customDomain.image.alt')
  });

  return /*#__PURE__*/_react["default"].createElement(Layout, (0, _extends2["default"])({
    onUpgrade: onUpgrade,
    onClose: onClose,
    title: t('paywall.customDomain.title'),
    subtitle: t('paywall.customDomain.subtitle'),
    image: image
  }, rest), t('paywall.customDomain.children'));
};

exports.CustomDomainPaywall = CustomDomainPaywall;

var SingleFileSizeLimitPaywall = function SingleFileSizeLimitPaywall(_ref5) {
  var limit = _ref5.limit,
      _ref5$noUpgrade = _ref5.noUpgrade,
      noUpgrade = _ref5$noUpgrade === void 0 ? false : _ref5$noUpgrade,
      onUpgrade = _ref5.onUpgrade,
      onClose = _ref5.onClose,
      rest = (0, _objectWithoutProperties2["default"])(_ref5, ["limit", "noUpgrade", "onUpgrade", "onClose"]);

  var _useTranslation5 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation5.t;

  var image = /*#__PURE__*/_react["default"].createElement(Image, {
    src: (0, _Image.withThemeSrc)(t('paywall.singleFileSizeLimit.image.src'), t('paywall.singleFileSizeLimit.darkImage.src')),
    alt: t('paywall.singleFileSizeLimit.image.alt')
  });

  var children = t('paywall.singleFileSizeLimit.children');

  if (noUpgrade) {
    children = t('paywall.singleFileSizeLimit.children.noUpgrade', {
      limit: limit
    });
  }

  return /*#__PURE__*/_react["default"].createElement(Layout, (0, _extends2["default"])({
    onUpgrade: !noUpgrade ? onUpgrade : undefined,
    onClose: onClose,
    title: t('paywall.singleFileSizeLimit.title'),
    subtitle: t('paywall.singleFileSizeLimit.subtitle'),
    image: image
  }, rest), children);
};

exports.SingleFileSizeLimitPaywall = SingleFileSizeLimitPaywall;

var AllowSubaccountsPaywall = function AllowSubaccountsPaywall(_ref6) {
  var onUpgrade = _ref6.onUpgrade,
      onClose = _ref6.onClose,
      rest = (0, _objectWithoutProperties2["default"])(_ref6, ["onUpgrade", "onClose"]);

  var _useTranslation6 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation6.t;

  var image = /*#__PURE__*/_react["default"].createElement(Image, {
    src: (0, _Image.withThemeSrc)(t('paywall.allowSubaccounts.image.src'), t('paywall.allowSubaccounts.darkImage.src')),
    alt: t('paywall.allowSubaccounts.image.alt')
  });

  return /*#__PURE__*/_react["default"].createElement(Layout, (0, _extends2["default"])({
    onUpgrade: onUpgrade,
    onClose: onClose,
    title: t('paywall.allowSubaccounts.title'),
    subtitle: t('paywall.allowSubaccounts.subtitle'),
    image: image
  }, rest), t('paywall.allowSubaccounts.children'));
};

exports.AllowSubaccountsPaywall = AllowSubaccountsPaywall;

var ContactAdmin = function ContactAdmin(_ref7) {
  var isOpen = _ref7.isOpen,
      toggle = _ref7.toggle,
      admin = _ref7.admin,
      onClose = _ref7.onClose;

  var _useTranslation7 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation7.t;

  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    open: isOpen,
    toggle: toggle,
    maxWidth: false
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "max-w-lg text-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-16"
  }, /*#__PURE__*/_react["default"].createElement("h1", {
    className: "font-bold text-dark text-3xl"
  }, t('paywall.contactAdmin.title')), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-light mt-3 mb-12"
  }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "paywall.contactAdmin.subtitle",
    values: {
      admin: admin
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold"
  }))), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: onClose,
    color: "primary",
    className: "w-48"
  }, t('paywall.contactAdmin.confirm')))));
};

exports.ContactAdmin = ContactAdmin;

var RetrofitUpgradeButton = function RetrofitUpgradeButton(props) {
  var _useTranslation8 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation8.t;

  return /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({
    className: "w-40"
  }, props), t('button.letGo'));
};

var RetrofitPaywall = function RetrofitPaywall(_ref8) {
  var onUpgrade = _ref8.onUpgrade,
      onClose = _ref8.onClose,
      rest = (0, _objectWithoutProperties2["default"])(_ref8, ["onUpgrade", "onClose"]);

  var _useTranslation9 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation9.t;

  var image = /*#__PURE__*/_react["default"].createElement(Image, {
    src: (0, _Image.withThemeSrc)(t('paywall.importAccounts.image.src'), t('paywall.importAccounts.darkImage.src')),
    alt: t('paywall.importAccounts.image.alt')
  });

  return /*#__PURE__*/_react["default"].createElement(Layout, (0, _extends2["default"])({
    onUpgrade: onUpgrade,
    onClose: onClose,
    title: t('paywall.retrofit.title'),
    image: image,
    UpgradeButton: RetrofitUpgradeButton
  }, rest), t('paywall.retrofit.description'));
};

exports.RetrofitPaywall = RetrofitPaywall;

var ScheduledBreakPaywall = function ScheduledBreakPaywall(_ref9) {
  var onUpgrade = _ref9.onUpgrade,
      onClose = _ref9.onClose,
      rest = (0, _objectWithoutProperties2["default"])(_ref9, ["onUpgrade", "onClose"]);

  var _useTranslation10 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation10.t;

  var image = /*#__PURE__*/_react["default"].createElement(Image, {
    src: (0, _Image.withThemeSrc)(t('paywall.scheduledBreak.image.src'), t('paywall.scheduledBreak.darkImage.src')),
    alt: t('paywall.scheduledBreak.image.alt')
  });

  return /*#__PURE__*/_react["default"].createElement(Layout, (0, _extends2["default"])({}, rest, {
    image: image,
    onClose: onClose,
    onUpgrade: onUpgrade,
    title: t('paywall.scheduledBreak.title')
  }), t('paywall.scheduledBreak.description'));
};

exports.ScheduledBreakPaywall = ScheduledBreakPaywall;
var StyledDialog = (0, _withStyles["default"])({
  root: {
    zIndex: 1301
  }
})(_Dialog["default"]);

var Layout = function Layout(_ref10) {
  var image = _ref10.image,
      onUpgrade = _ref10.onUpgrade,
      onClose = _ref10.onClose,
      title = _ref10.title,
      subtitle = _ref10.subtitle,
      children = _ref10.children,
      isOpen = _ref10.isOpen,
      _ref10$UpgradeButton = _ref10.UpgradeButton,
      UpgradeButton = _ref10$UpgradeButton === void 0 ? Upgrade : _ref10$UpgradeButton,
      rest = (0, _objectWithoutProperties2["default"])(_ref10, ["image", "onUpgrade", "onClose", "title", "subtitle", "children", "isOpen", "UpgradeButton"]);
  return /*#__PURE__*/_react["default"].createElement(StyledDialog, (0, _extends2["default"])({
    maxWidth: false,
    open: isOpen,
    toggle: onClose
  }, rest), /*#__PURE__*/_react["default"].createElement("div", {
    className: "max-w-screen-md"
  }, /*#__PURE__*/_react["default"].createElement(Close, {
    onClick: onClose
  }), image, /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-8 mt-5"
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "text-sm font-semibold text-light"
  }, subtitle), /*#__PURE__*/_react["default"].createElement("h1", {
    className: "font-bold text-dark text-2xl"
  }, title), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-light mt-8 mb-12"
  }, children), onUpgrade ? /*#__PURE__*/_react["default"].createElement(UpgradeButton, {
    onClick: onUpgrade
  }) : /*#__PURE__*/_react["default"].createElement(Okay, {
    onClick: onClose
  }))));
};

var Upgrade = function Upgrade(props) {
  var _useTranslation11 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation11.t;

  return /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({
    className: "w-40"
  }, props), t('button.upgrade'));
};

var Okay = function Okay(props) {
  var _useTranslation12 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation12.t;

  return /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({
    className: "w-40"
  }, props), t('button.okay'));
};

var Close = function Close(props) {
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: "bg-app dark:bg-card shadow-lg dark:shadow-shallow absolute top-0 right-0 mt-5 mr-5 p-2 rounded-full cursor-pointer hover:bg-secondary hover:text-primary text-light dark:hover:text-dark"
  }, props), /*#__PURE__*/_react["default"].createElement(_Clear["default"], null));
};

var Image = function Image(props) {
  return /*#__PURE__*/_react["default"].createElement(_Image["default"], (0, _extends2["default"])({
    width: "1000",
    height: "370",
    className: "dark:shadow-xl dark:bg-secondary"
  }, props));
};
//# sourceMappingURL=index.js.map